import React, { useState, useEffect } from "react";
import UnmetNeedsPage from "../UnmetNeeds/UnmetNeedsPage";
import UnmetNeedsIntro from "../UnmetNeeds/UnmetNeedsIntro";

const UnmetNeeds = ({ 
  title = "Coming Soon", 
  subtitle = "This section is under construction.",
  onToggleImmersive,   
  userId,
  subsectionId,
  initialData,
  onComplete,
  course,
  onSelectModule,   
  onSelectSubsection 
}) => {
  const [showPage, setShowPage] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  const handleGetStarted = () => {
    setShowPage(true);
    setShouldAnimate(true);
  };

  // ✅ Debug logging
  useEffect(() => {
    console.log("🔍 UnmetNeeds Wrapper Props:", {
      userId,
      subsectionId,
      initialData,
      showPage
    });
  }, [userId, subsectionId, initialData, showPage]);

  // Jab UnmetNeedsPage show ho tab immersive mode enable karo
  useEffect(() => {
    if (showPage && onToggleImmersive) {
      onToggleImmersive(true);
    }

    // Cleanup: jab component unmount ho ya showPage false ho
    return () => {
      if (onToggleImmersive) {
        onToggleImmersive(false);
      }
    };
  }, [showPage, onToggleImmersive]);

  return (
    <>
      <div 
        className={`w-full h-full flex flex-col items-center justify-center bg-white text-center rounded-2xl p-10 ${
          shouldAnimate ? 'full-page-blink-glow' : ''
        }`}
      >
        {!showPage ? (
          <UnmetNeedsIntro onGetStarted={handleGetStarted} />
        ) : (
          <UnmetNeedsPage 
            userId={userId}
            subsectionId={subsectionId}
            initialData={initialData}
            onComplete={onComplete} 
            course={course}
            onSelectModule={onSelectModule}
            onSelectSubsection={onSelectSubsection}
          />
        )}
      </div>

      {/* ✨ Full Page Blink Glow - Sab kuch blink karega, position same */}
      <style jsx>{`
        @keyframes fullPageBlinkGlow {
          0% {
            opacity: 0.3;
            filter: brightness(1.5);
          }
          25% {
            opacity: 0.6;
            filter: brightness(1.3);
          }
          50% {
            opacity: 0.8;
            filter: brightness(1.5);
          }
          75% {
            opacity: 0.9;
            filter: brightness(1.2);
          }
          100% {
            opacity: 1;
            filter: brightness(1);
          }
        }

        .full-page-blink-glow {
          animation: fullPageBlinkGlow 0.8s ease-in-out;
        }
      `}</style>
    </>
  );
};

export default UnmetNeeds;